import {
  clearSrDocumentStatusAction,
  deleteSrDocumentStatus,
} from 'actions/srDocuments/srDocumentStatusActions'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'

const SrDocumentStatusDelete = ({ formId, closeModal, selected }) => {
  //// HOOKS.
  const dispatch = useDispatch()

  //// GLOBAL STATE.

  //// LOCAL STATE.

  //// LIFECYCLE HELPERS.

  //// MEMOS.

  //// EFFECTS.
  useEffect(() => {
    return () => {
      dispatch(clearSrDocumentStatusAction())
    }
  }, [dispatch])

  //// RENDER VARS & HELPERS.

  //// RENDER.
  return (
    <form
      id={formId}
      onSubmit={(e) => {
        e.preventDefault()
        dispatch(deleteSrDocumentStatus(selected))
        closeModal()
      }}
      className="form container"
    >
      <div>
        Are you sure you want to delete this Site Readiness Document Status?
        This can not be undone.
      </div>
    </form>
  )
}

export default SrDocumentStatusDelete
